import * as i0 from '@angular/core';
import { Pipe, inject, ElementRef, ChangeDetectorRef, Component, Input, NgModule, InjectionToken } from '@angular/core';
import { NgIf, NgSwitch, NgSwitchCase, CommonModule } from '@angular/common';
import { IntersectionService, CoerceBooleanPropertyPipe, CoersionModule } from '@virginmediao2/momentum-angular/utilities';
export * from '@virginmediao2/momentum-angular/utilities';
export * from '@virginmediao2/momentum-angular/components/accordion';
export * from '@virginmediao2/momentum-angular/components/alert';
export * from '@virginmediao2/momentum-angular/components/anchor';
export * from '@virginmediao2/momentum-angular/components/banner';
export * from '@virginmediao2/momentum-angular/components/breadcrumbs';
export * from '@virginmediao2/momentum-angular/components/button';
export * from '@virginmediao2/momentum-angular/components/card';
export * from '@virginmediao2/momentum-angular/components/connected-overlay';
export * from '@virginmediao2/momentum-angular/components/content';
export * from '@virginmediao2/momentum-angular/components/countdown';
export * from '@virginmediao2/momentum-angular/components/customer-effort-score';
export * from '@virginmediao2/momentum-angular/components/elements';
export * from '@virginmediao2/momentum-angular/components/footer';
export * from '@virginmediao2/momentum-angular/components/header';
export * from '@virginmediao2/momentum-angular/components/hero-banner';
export * from '@virginmediao2/momentum-angular/components/icon';
export * from '@virginmediao2/momentum-angular/components/list';
export * from '@virginmediao2/momentum-angular/components/loading-logo';
export * from '@virginmediao2/momentum-angular/components/loading-pips';
export * from '@virginmediao2/momentum-angular/components/modal';
export * from '@virginmediao2/momentum-angular/components/page-interrupt';
export * from '@virginmediao2/momentum-angular/components/poptip';
export * from '@virginmediao2/momentum-angular/components/pricing';
export * from '@virginmediao2/momentum-angular/components/promo-banner';
export * from '@virginmediao2/momentum-angular/components/promo-flag';
export * from '@virginmediao2/momentum-angular/components/section';
export * from '@virginmediao2/momentum-angular/components/segmented-navigation';
export * from '@virginmediao2/momentum-angular/components/shout-out-banner';
export * from '@virginmediao2/momentum-angular/components/show-more';
export * from '@virginmediao2/momentum-angular/components/sidenav';
export * from '@virginmediao2/momentum-angular/components/skip-links';
export * from '@virginmediao2/momentum-angular/components/social-proofing';
export * from '@virginmediao2/momentum-angular/components/step-indicator';
export * from '@virginmediao2/momentum-angular/components/table';
export * from '@virginmediao2/momentum-angular/components/tabs';
export * from '@virginmediao2/momentum-angular/components/text';
export * from '@virginmediao2/momentum-angular/components/theme-provider-o2';
export * from '@virginmediao2/momentum-angular/components/theme-provider-vm';
export * from '@virginmediao2/momentum-angular/components/theme-provider-vmo2';
export * from '@virginmediao2/momentum-angular/components/tile';
export * from '@virginmediao2/momentum-angular/components/user-rating';
export * from '@virginmediao2/momentum-angular/forms/form-calendar';
export * from '@virginmediao2/momentum-angular/forms/form-checkbox';
export * from '@virginmediao2/momentum-angular/forms/form-expandable-card';
export * from '@virginmediao2/momentum-angular/forms/form-filter-chip';
export * from '@virginmediao2/momentum-angular/forms/form-input';
export * from '@virginmediao2/momentum-angular/forms/form-item';
export * from '@virginmediao2/momentum-angular/forms/form-list';
export * from '@virginmediao2/momentum-angular/forms/form-multi-item';
export * from '@virginmediao2/momentum-angular/forms/form-radio';
export * from '@virginmediao2/momentum-angular/forms/form-select';
export * from '@virginmediao2/momentum-angular/forms/form-select-search';
export * from '@virginmediao2/momentum-angular/forms/form-selectable-calendar';
export * from '@virginmediao2/momentum-angular/forms/form-selectable-card';
export * from '@virginmediao2/momentum-angular/forms/form-textarea';
export * from '@virginmediao2/momentum-angular/forms/form-toggle';
export * from '@virginmediao2/momentum-angular/forms/form-vertical';
export * from '@virginmediao2/momentum-angular/forms/segmented-control';
export * from '@virginmediao2/momentum-angular/services/header-navigation';
export * from '@virginmediao2/momentum-angular/services/overlay';
export * from '@virginmediao2/momentum-angular/services/theme';
export * from '@virginmediao2/momentum-angular/directives/remove-from-view';
export * from '@virginmediao2/momentum-angular/types';

class AltDefinedOrEmptyPipe {
    transform(alt, fallback) {
        return alt || fallback || '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: AltDefinedOrEmptyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: AltDefinedOrEmptyPipe, isStandalone: true, name: "altDefinedOrEmpty" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: AltDefinedOrEmptyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'altDefinedOrEmpty',
                    standalone: true,
                }]
        }] });

class AspectRatioPipe {
    calculateRatio(width, height) {
        let numerator = 0;
        let denominator = 0;
        for (let num = height; num > 1; num--) {
            if (width % num === 0 && height % num === 0) {
                numerator = width / num;
                denominator = height / num;
                break;
            }
        }
        return `${numerator} / ${denominator}`;
    }
    transform({ default: defaultImg }) {
        const { height, width } = defaultImg;
        return height && width ? `aspect-ratio: ${this.calculateRatio(width, height)};` : null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: AspectRatioPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: AspectRatioPipe, isStandalone: true, name: "aspectRatio" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: AspectRatioPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'aspectRatio',
                    pure: true,
                    standalone: true,
                }]
        }] });

const createStrapiImage = (base, url, width, height, mime) => ({
    url: `${base}${url}`,
    width,
    height,
    mime,
});
class MediaSrcStrapiPipe {
    transform(media, base = '', maxWidth) {
        if (!media) {
            return null;
        }
        const allImages = Object.values(media.formats || {}).reduce((acc, current) => {
            const imageSet = [];
            const originalImage = createStrapiImage(base, current.url, current.width, current.height, current.mime);
            imageSet.push(originalImage);
            if (current.webPURL) {
                const webp = createStrapiImage(base, current.webPURL, current.width, current.height, 'image/webp');
                imageSet.push(webp);
            }
            return [...acc, ...imageSet];
        }, []);
        if (media.webPURL) {
            const originalImgWebP = createStrapiImage(base, media.webPURL, media.width, media.height, 'image/webp');
            allImages.push(originalImgWebP);
        }
        const originalImg = createStrapiImage(base, media.url, media.width, media.height, media.mime);
        allImages.push(originalImg);
        const images = allImages
            .filter((image) => (maxWidth ? image.width <= maxWidth : true))
            .sort((a, b) => a.width - b.width);
        // If all images have been size filtered, then pick the smallest
        if (!images.length) {
            const allNonWebP = allImages
                .filter((image) => image.mime !== 'image/webp')
                .sort((a, b) => a.width - b.width);
            const allWebP = allImages.filter((image) => image.mime === 'image/webp').sort((a, b) => a.width - b.width);
            images.push(allNonWebP[0]);
            if (allWebP.length) {
                images.push(allWebP[0]);
            }
        }
        // Find last non-webP image to use as the default image, and removes it from images array
        const nonWebPImages = images.filter((image) => image.mime !== 'image/webp');
        const [largestNonWebP] = nonWebPImages.slice(-1);
        const largestNonWebPIndex = images.indexOf(largestNonWebP);
        images.splice(largestNonWebPIndex, 1);
        return {
            alt: media.alternativeText,
            default: largestNonWebP,
            images,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaSrcStrapiPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: MediaSrcStrapiPipe, isStandalone: true, name: "mediaSrcStrapi" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaSrcStrapiPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'mediaSrcStrapi',
                    pure: true,
                    standalone: true,
                }]
        }] });

class SrcSizesPipe {
    transform(sources) {
        const sizeSet = new Set();
        [...sources.images, sources.default].forEach((image) => sizeSet.add(image.width));
        const sizes = [...sizeSet].sort((a, b) => a - b).map((size) => `(max-width: ${size}px) ${size}px`);
        sizes.push('100vw');
        return sizes.join(', ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SrcSizesPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SrcSizesPipe, isStandalone: true, name: "srcSizes" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SrcSizesPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'srcSizes',
                    pure: true,
                    standalone: true,
                }]
        }] });

class SrcSetPipe {
    transform(sources, fallback = false) {
        return [...sources.images, sources.default]
            .filter(({ mime }) => (fallback ? mime !== 'image/webp' : mime === 'image/webp'))
            .map((image) => `${image.url} ${image.width}w`)
            .join(', ');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SrcSetPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: SrcSetPipe, isStandalone: true, name: "srcSet" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: SrcSetPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'srcSet',
                    pure: true,
                    standalone: true,
                }]
        }] });

var MIME_TYPE;
(function (MIME_TYPE) {
    MIME_TYPE["MP4"] = "video/mp4";
    MIME_TYPE["WEBM"] = "video/webm";
    MIME_TYPE["OGG"] = "video/ogg";
})(MIME_TYPE || (MIME_TYPE = {}));
const MP4_Extensions = ['mp4', 'mpg', 'mpeg', 'm4a', 'm4b', 'm4v'];
const WebM_Extensions = ['webm', 'webma', 'webmv', 'webmv'];
const Ogg_Extensions = ['ogv', 'ogm', 'ogx', 'ogg'];
class VideoMimeTypePipe {
    transform(value) {
        const extension = value.toLowerCase().split('.').pop();
        if (extension && MP4_Extensions.includes(extension)) {
            return MIME_TYPE.MP4;
        }
        if (extension && WebM_Extensions.includes(extension)) {
            return MIME_TYPE.WEBM;
        }
        if (extension && Ogg_Extensions.includes(extension)) {
            return MIME_TYPE.OGG;
        }
        return undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: VideoMimeTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: VideoMimeTypePipe, isStandalone: true, name: "videoMimeType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: VideoMimeTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'videoMimeType',
                    pure: true,
                    standalone: true,
                }]
        }] });

var MediaType;
(function (MediaType) {
    MediaType["video"] = "video";
    MediaType["image"] = "image";
})(MediaType || (MediaType = {}));
const VideoTypes = [...MP4_Extensions, ...WebM_Extensions, ...Ogg_Extensions];
const ImageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];
class MediaTypePipe {
    transform(value) {
        const extension = value.toLowerCase().split('.').pop();
        if (extension && VideoTypes.includes(extension)) {
            return MediaType.video;
        }
        if (extension && ImageTypes.includes(extension)) {
            return MediaType.image;
        }
        return undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: MediaTypePipe, isStandalone: true, name: "mediaType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'mediaType',
                    pure: true,
                    standalone: true,
                }]
        }] });

class MediaComponent {
    constructor() {
        this.render = false;
        /** Alternative Text for the media */
        this.alt = '';
        /** Configures whether the media should have a border */
        this.border = false;
        /** Configures whether the media should be lazy loaded */
        this.lazyLoad = true;
        /** Percentage of media which must be considered in view before loading */
        this.lazyThreshold = 0.05;
        /** Distance from viewport before loading */
        this.lazyScreenOffset = '300px';
        /** Configures the CSS object fit for media */
        this.objectFit = 'contain';
        this.intersection = inject(IntersectionService);
        this.element = inject(ElementRef);
        this.cdRef = inject(ChangeDetectorRef);
    }
    renderMedia() {
        this.render = true;
        this.cdRef.detectChanges();
        if (this.intersectionObserver) {
            this.intersectionObserver.unobserve(this.element.nativeElement);
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
        }
    }
    attachIntersectionObserver() {
        const intersectionFn = (entries) => {
            const intersecting = entries.some(({ isIntersecting }) => isIntersecting);
            if (intersecting) {
                this.renderMedia();
            }
        };
        const options = {
            threshold: this.lazyThreshold,
            rootMargin: this.lazyScreenOffset,
        };
        this.intersectionObserver = this.intersection.create(intersectionFn, options);
        this.intersectionObserver.observe(this.element.nativeElement);
    }
    ngOnInit() {
        if (this.intersection.isSupported() && this.lazyLoad) {
            this.attachIntersectionObserver();
        }
        else {
            this.render = true;
        }
    }
    ngOnChanges(changes) {
        if (changes['src']?.currentValue && changes['mediaSrc']?.currentValue) {
            throw new Error('Media Component: Please only provide `src` or `mediaSrc`');
        }
    }
    ngOnDestroy() {
        if (this.intersectionObserver) {
            this.intersectionObserver.unobserve(this.element.nativeElement);
            this.intersectionObserver.disconnect();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.4", type: MediaComponent, isStandalone: true, selector: "vo-media", inputs: { aspectRatio: "aspectRatio", alt: "alt", border: "border", lazyLoad: "lazyLoad", lazyThreshold: "lazyThreshold", lazyScreenOffset: "lazyScreenOffset", mediaSrc: "mediaSrc", src: "src", objectFit: "objectFit" }, usesOnChanges: true, ngImport: i0, template: "<div\n    *ngIf=\"src\"\n    class=\"vm-media\"\n    [class.vm-media--aspect-1-1]=\"aspectRatio === '1:1'\"\n    [class.vm-media--aspect-2-1]=\"aspectRatio === '2:1'\"\n    [class.vm-media--aspect-4-3]=\"aspectRatio === '4:3'\"\n    [class.vm-media--aspect-16-9]=\"aspectRatio === '16:9'\"\n    [class.vm-media--contain]=\"objectFit === 'contain'\"\n    [class.vm-media--cover]=\"objectFit === 'cover'\"\n    [class.vm-media--has-border]=\"border | coerceBooleanProperty\">\n    <ng-container\n        *ngIf=\"render\"\n        [ngSwitch]=\"src | mediaType\">\n        <video\n            *ngSwitchCase=\"'video'\"\n            class=\"vm-media__media\"\n            controls\n            preload=\"metadata\"\n            [title]=\"alt | altDefinedOrEmpty\">\n            <source\n                [type]=\"src | videoMimeType\"\n                [src]=\"src\" />\n        </video>\n\n        <img\n            *ngSwitchCase=\"'image'\"\n            loading=\"lazy\"\n            class=\"vm-media__media\"\n            [src]=\"src\"\n            [alt]=\"alt | altDefinedOrEmpty\" />\n    </ng-container>\n</div>\n\n<picture\n    *ngIf=\"mediaSrc\"\n    class=\"vm-media vm-media--contain\"\n    [class.vm-media--has-border]=\"border | coerceBooleanProperty\"\n    [attr.style]=\"mediaSrc | aspectRatio\">\n    <ng-container *ngIf=\"render\">\n        <source\n            [sizes]=\"mediaSrc | srcSizes\"\n            [srcset]=\"mediaSrc | srcSet\"\n            type=\"image/webp\" />\n\n        <img\n            loading=\"lazy\"\n            class=\"vm-media__media\"\n            [src]=\"mediaSrc.default.url\"\n            [alt]=\"alt | altDefinedOrEmpty : mediaSrc.alt\"\n            [sizes]=\"mediaSrc | srcSizes\"\n            [srcset]=\"mediaSrc | srcSet : true\"\n            [width]=\"mediaSrc.default.width\"\n            [height]=\"mediaSrc.default.height\" />\n    </ng-container>\n</picture>\n", styles: [".vm-media{box-sizing:border-box;max-width:100%}.vm-media--cover .vm-media__media{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.vm-media--contain{display:inline-block}.vm-media--contain .vm-media__media{-o-object-fit:contain;object-fit:contain;max-width:100%}.vm-media--has-border{border:var(--mo-media-border)}.vm-media--aspect-1-1{aspect-ratio:1}.vm-media--aspect-2-1{aspect-ratio:2/1}.vm-media--aspect-16-9{display:inline-block;aspect-ratio:16/9}.vm-media__media{border:none;vertical-align:middle}:host{display:flex}\n"], dependencies: [{ kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "pipe", type: CoerceBooleanPropertyPipe, name: "coerceBooleanProperty" }, { kind: "pipe", type: SrcSetPipe, name: "srcSet" }, { kind: "pipe", type: SrcSizesPipe, name: "srcSizes" }, { kind: "pipe", type: AltDefinedOrEmptyPipe, name: "altDefinedOrEmpty" }, { kind: "pipe", type: AspectRatioPipe, name: "aspectRatio" }, { kind: "pipe", type: MediaTypePipe, name: "mediaType" }, { kind: "pipe", type: VideoMimeTypePipe, name: "videoMimeType" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'vo-media', standalone: true, imports: [
                        NgIf,
                        NgSwitch,
                        NgSwitchCase,
                        CoerceBooleanPropertyPipe,
                        SrcSetPipe,
                        SrcSizesPipe,
                        AltDefinedOrEmptyPipe,
                        AspectRatioPipe,
                        MediaTypePipe,
                        VideoMimeTypePipe,
                    ], template: "<div\n    *ngIf=\"src\"\n    class=\"vm-media\"\n    [class.vm-media--aspect-1-1]=\"aspectRatio === '1:1'\"\n    [class.vm-media--aspect-2-1]=\"aspectRatio === '2:1'\"\n    [class.vm-media--aspect-4-3]=\"aspectRatio === '4:3'\"\n    [class.vm-media--aspect-16-9]=\"aspectRatio === '16:9'\"\n    [class.vm-media--contain]=\"objectFit === 'contain'\"\n    [class.vm-media--cover]=\"objectFit === 'cover'\"\n    [class.vm-media--has-border]=\"border | coerceBooleanProperty\">\n    <ng-container\n        *ngIf=\"render\"\n        [ngSwitch]=\"src | mediaType\">\n        <video\n            *ngSwitchCase=\"'video'\"\n            class=\"vm-media__media\"\n            controls\n            preload=\"metadata\"\n            [title]=\"alt | altDefinedOrEmpty\">\n            <source\n                [type]=\"src | videoMimeType\"\n                [src]=\"src\" />\n        </video>\n\n        <img\n            *ngSwitchCase=\"'image'\"\n            loading=\"lazy\"\n            class=\"vm-media__media\"\n            [src]=\"src\"\n            [alt]=\"alt | altDefinedOrEmpty\" />\n    </ng-container>\n</div>\n\n<picture\n    *ngIf=\"mediaSrc\"\n    class=\"vm-media vm-media--contain\"\n    [class.vm-media--has-border]=\"border | coerceBooleanProperty\"\n    [attr.style]=\"mediaSrc | aspectRatio\">\n    <ng-container *ngIf=\"render\">\n        <source\n            [sizes]=\"mediaSrc | srcSizes\"\n            [srcset]=\"mediaSrc | srcSet\"\n            type=\"image/webp\" />\n\n        <img\n            loading=\"lazy\"\n            class=\"vm-media__media\"\n            [src]=\"mediaSrc.default.url\"\n            [alt]=\"alt | altDefinedOrEmpty : mediaSrc.alt\"\n            [sizes]=\"mediaSrc | srcSizes\"\n            [srcset]=\"mediaSrc | srcSet : true\"\n            [width]=\"mediaSrc.default.width\"\n            [height]=\"mediaSrc.default.height\" />\n    </ng-container>\n</picture>\n", styles: [".vm-media{box-sizing:border-box;max-width:100%}.vm-media--cover .vm-media__media{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.vm-media--contain{display:inline-block}.vm-media--contain .vm-media__media{-o-object-fit:contain;object-fit:contain;max-width:100%}.vm-media--has-border{border:var(--mo-media-border)}.vm-media--aspect-1-1{aspect-ratio:1}.vm-media--aspect-2-1{aspect-ratio:2/1}.vm-media--aspect-16-9{display:inline-block;aspect-ratio:16/9}.vm-media__media{border:none;vertical-align:middle}:host{display:flex}\n"] }]
        }], propDecorators: { aspectRatio: [{
                type: Input
            }], alt: [{
                type: Input
            }], border: [{
                type: Input
            }], lazyLoad: [{
                type: Input
            }], lazyThreshold: [{
                type: Input
            }], lazyScreenOffset: [{
                type: Input
            }], mediaSrc: [{
                type: Input
            }], src: [{
                type: Input
            }], objectFit: [{
                type: Input
            }] } });

class MediaModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.4", ngImport: i0, type: MediaModule, imports: [CommonModule,
            CoersionModule,
            MediaComponent,
            MediaSrcStrapiPipe,
            SrcSetPipe,
            SrcSizesPipe,
            AltDefinedOrEmptyPipe,
            AspectRatioPipe,
            MediaTypePipe,
            VideoMimeTypePipe], exports: [MediaComponent, MediaSrcStrapiPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaModule, providers: [IntersectionService], imports: [CommonModule,
            CoersionModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.4", ngImport: i0, type: MediaModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        CoersionModule,
                        MediaComponent,
                        MediaSrcStrapiPipe,
                        SrcSetPipe,
                        SrcSizesPipe,
                        AltDefinedOrEmptyPipe,
                        AspectRatioPipe,
                        MediaTypePipe,
                        VideoMimeTypePipe,
                    ],
                    exports: [MediaComponent, MediaSrcStrapiPipe],
                    providers: [IntersectionService],
                }]
        }] });

const VO_GLOBAL_CONFIG = new InjectionToken('PL.config');

/**
 * Generated bundle index. Do not edit.
 */

export { AltDefinedOrEmptyPipe, AspectRatioPipe, MIME_TYPE, MP4_Extensions, MediaComponent, MediaModule, MediaSrcStrapiPipe, MediaType, MediaTypePipe, Ogg_Extensions, SrcSetPipe, SrcSizesPipe, VO_GLOBAL_CONFIG, VideoMimeTypePipe, WebM_Extensions };
